import React, {useEffect, useMemo, useState} from 'react';
import {Box, ListItemText, Pagination, Radio, TextField,} from '@mui/material';
import ApiClient from "../sdk/ApiClient";
import {useKeycloak} from "@react-keycloak/web";

const MissionSelection = ({onMissionSelectCallBack}) => {
    const itemsPerPage = 10; // Nombre d'éléments par page

    const {keycloak} = useKeycloak();

    // État pour le filtre, la page courante et la mission sélectionnée
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedMissionId, setSelectedMissionId] = useState(null);
    const [missions, setMissions] = useState([]);

    const apiClientInstance = useMemo(() => new ApiClient(keycloak.token), [keycloak.token]);

    // useEffect pour exécuter fetchMissions au chargement de la page
    useEffect(() => {
        const fetchMissions = async () => {
            try {
                const data = await apiClientInstance.getMissions()
                setMissions(data); // Stocke les missions dans l'état
            } catch (error) {
                console.error("Erreur lors de la récupération des missions :", error);
            }
        }

        fetchMissions();
    }, [apiClientInstance]);

    // **Filtrage des missions**
    const filteredMissions = useMemo(() => {
        if (!searchQuery || searchQuery.trim().length === 0) {
            return missions;
        }
        return missions.filter(
            (mission) =>
                mission.id.toString().includes(searchQuery) ||
                mission.label.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }, [missions, searchQuery]);

    // **Pagination**
    const pageCount = Math.ceil(filteredMissions.length / itemsPerPage); // Calcul du nombre de pages
    const paginatedMissions = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        return filteredMissions.slice(start, start + itemsPerPage);
    }, [filteredMissions, currentPage]);

    // Gestion du changement de page
    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    // Gestion du filtre de recherche
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1); // Revient à la première page lors d'un nouveau filtre
    };

    // Gestion de la sélection de mission
    const handleMissionSelect = (id) => {
        setSelectedMissionId(id);
        onMissionSelectCallBack(id);
    };


    return (
        <Box flexDirection={"column"} height={"80vh"} id={"MissionSelection"}>
            {/* Filtre de recherche */}
            <TextField
                label="Rechercher (ID ou Description)"
                variant="outlined"
                fullWidth
                value={searchQuery}
                onChange={handleSearchChange}
                margin="normal"
            />

            {/* Liste des missions paginées */}
            <Box
                fullWidth
                sx={{

                    display: "grid",              // Utilisation de CSS grid
                    gridTemplateColumns: "1fr 1fr", // Deux colonnes de taille égale
                    gap: 2,                       // Espacement horizontal entre les deux colonnes
                    overflowY: "auto",
                    maxHeight: "60vh",
                }}
            >
                {missions.length > 0 &&
                    paginatedMissions.map((mission) => (
                        <Box
                            key={mission.id}
                            sx={{
                                height: "7vh",
                                display: "flex",
                                alignItems: "center",
                                p: 1,             // Padding à l'intérieur des items
                                cursor: "pointer",
                                border: selectedMissionId === mission.id ? "2px solid #1976d2" : "1px solid #ccc",
                                borderRadius: "8px",
                            }}
                            onClick={() => handleMissionSelect(mission.id)}
                        >
                            {/* Case à cocher pour sélectionner la mission */}
                            <Radio
                                checked={selectedMissionId === mission.id}
                                value={mission.id}
                                onChange={() => handleMissionSelect(mission.id)}
                            />
                            {/* Texte descriptif de la mission */}
                            <ListItemText
                                color="primary"
                                sx={{textAlign: "left"}}
                                primary={mission.label}
                                secondary={`Mission ID: ${mission.id}`}
                            />
                        </Box>
                    ))}
            </Box>


            {/* Pagination */}
            {pageCount > 1 && (
                <Box display="flex" justifyContent="center" marginTop={2}>
                    <Pagination
                        count={pageCount}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="primary"
                    />
                </Box>
            )}
        </Box>
    );
};

export default MissionSelection;
